(ns app.front.view.payment.heartland
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.payment.checkout :as checkout]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-db ::update-zip-code
  (fn [db [_ zip]]
    (assoc db ::zip-code zip)))

(rf/reg-sub ::zip-code :-> ::zip-code)

(rf/reg-event-db ::update-address
  (fn [db [_ address]]
    (assoc db ::address address)))

(rf/reg-sub ::address :-> ::address)

(rf/reg-event-fx ::charge-card
  (fn [_ [_ token payment-id zip-code address return-route-key]]
    (if (and (not-empty zip-code) (not-empty address))
      {:comm/command {:command         :payment/heartland-charge-card
                      :data            {:payment-token token
                                        :payment-id    payment-id
                                        :zip-code      zip-code
                                        :address       address}
                      :on-bad-request  [::charge.fail return-route-key]
                      :on-server-error [::charge.fail return-route-key]
                      :on-success      [::charge.success return-route-key]}}
      {:dispatch [:notifications/add :toast :error :error/payment-failed-title :error/required-fields-missing]})))

(rf/reg-event-fx ::charge.fail ;; test this with escrow
  (fn [{:keys [db]} [_ return-route-key _status body]]
    (merge
      {:dispatch [:notifications/add :toast :error :error/payment-failed-title
                  (or (:error body) :error/unknown)]}
      (checkout/return-nav-fx db return-route-key (-> db :route/match :path-params)))))

(rf/reg-event-fx ::charge.success
  (fn [{:keys [db]} [_ return-route-key _status body]]
    (let [escrow?      (= return-route-key :view/escrow-account.transactions)
          default-nav  (checkout/return-nav-fx db return-route-key (-> db :route/match :path-params))
          route-result (:route/replace default-nav)]
      (merge {:db (:db default-nav)}
             (if escrow?
               {:route/push (assoc route-result :query {:transaction-id (:transaction-id body)})
                :dispatch   [:notifications/add :toast :success :success :payment/success-escrow-deposit]}
               {:route/push route-result})))))

(rf/reg-event-fx :handle-token-success
  (fn [{:keys [db]} [_ ^js resp payment-id users-zip users-address return-route-key]]
    (let [token-value (:paymentReference resp)
          zip-code    (or (::zip-code db) users-zip)
          address     (or (::address db) users-address)]
      (>evt [::charge-card token-value payment-id zip-code address return-route-key]))))

(rf/reg-event-fx :handle-token-error
  (fn [{:keys [db]} [_ ^js resp return-route-key]]
    (let [error-reason (-> resp :reasons first :code)]
      (merge
        {:dispatch [:notifications/add :toast :error :error/payment-failed-title
                    (or error-reason :error/unknown)]}
        (checkout/return-nav-fx db return-route-key (-> db :route/match :path-params))))))

(defn create-card-form [{:keys                            [workspace-id]
                         {:keys [payment-id zip address]} :ctx}]
  (let [heartland        js/GlobalPayments
        card-form        (.form (.-creditCard heartland) "#credit-card")
        return-route-key (if workspace-id :view/workspace :view/escrow-account.transactions)]
    (.on card-form "token-success"
         (fn [resp]
           (rf/dispatch [:handle-token-success (js->clj resp :keywordize-keys true) payment-id zip address return-route-key])))
    (.on card-form "token-error"
         (fn [resp]
           (rf/dispatch [:handle-token-error (js->clj resp :keywordize-keys true) return-route-key])))))

(defn embedded-form [details]
  (when (exists? js/GlobalPayments)
    (r/create-class
      {:component-did-mount (fn []
                              (.configure js/GlobalPayments #js {:publicApiKey (-> details :ctx :public-key)})
                              (create-card-form details))
       :reagent-render      (fn []
                              (let [changed-zip-code (<sub [::zip-code])
                                    zip-code         (or changed-zip-code (-> details :ctx :zip))
                                    changed-address  (<sub [::address])
                                    address          (or changed-address (-> details :ctx :address))
                                    tr               (<sub [::ws-subs/tr])]
                                [:form {:id     "payment-form"
                                        :method "POST"}
                                 [:div.pt-2.pl-2
                                  [:div.py-6.font-bold.text-lg
                                   [:div (tr [:payment/fill-all-fields])]]
                                  [:div.w-72
                                   [ui/text-input {:id          "heartland-billing-zip"
                                                   :label-text  (tr [:payment/billing-zip-code])
                                                   :value       zip-code
                                                   :on-change   #(>evt [::update-zip-code (futil/tval %)])
                                                   :light       true
                                                   :class       "pb-2"
                                                   :label-class "font-bold"}]
                                   [ui/text-input {:id          "heartland-billing-address"
                                                   :label-text  (tr [:payment/billing-address])
                                                   :value       address
                                                   :on-change   #(>evt [::update-address (futil/tval %)])
                                                   :light       true
                                                   :class       "pb-2"
                                                   :label-class "font-bold"}]]
                                  [:div {:id "credit-card"}]]]))})))

(defmethod checkout/payment-form :payment-service/heartland
  [details]
  [futil/js-loader
   {:id  "heartland-script"
    :src "/asset/js/globalpayments.js"}
   (cc/inline-loading {:description "Loading heartland"})
   [embedded-form details]])
